import  * as PowerBIConstants from './PowerBIContants';
import PowerBIUtil from './PowerBIUtil';


const addDeviceToPowerBIReducerState = (instanceId) => {
	return {
		type: PowerBIConstants.POWERBI_DEVICE_STATE_ADD,
		payload: instanceId
	}
};

const removeDeviceFromPowerBIReducerState = (instanceId) => {
	return {
		type: PowerBIConstants.POWERBI_DEVICE_STATE_REMOVE,
		payload: instanceId
	}
};

const  getWorkspaceID  = async (instanceId, url,token,dispatch)=> {
	await  PowerBIUtil.getData(instanceId, url,token,dispatch,GroupDataSuccess,GroupDataSuccessFailure);
}

const GroupDataSuccess=(instanceId, data)=>{
	var length = (data.value).length;
	var arr ='';
   
  for(var i=0;i<length;i++)
	{
		 if((data.value)[i].name == process.env.PowerBI_Workspace)
			  arr=(data.value)[i].id;
	}
	return { type: PowerBIConstants.POWERBI_GROUP_API_SUCCESS, payload: { instanceId, newState : arr }};
}

const GroupDataSuccessFailure=(instanceId)=>{
	  
    return { type: PowerBIConstants.POWERBI_GROUP_API_FAILURE, payload: instanceId};
}

// Get Report ID
const  getPowerBIData  = async (instanceId, url,token,dispatch)=> {

	await  PowerBIUtil.getData(instanceId, url,token,dispatch,PowerBIDataSuccess,PowerBIDataFailure);
}

const PowerBIDataSuccess=(instanceId, data)=>{
	return { type: PowerBIConstants.POWERBI_API_SUCCESS, payload : { instanceId, newState: data }};
}

const PowerBIDataFailure=(instanceId)=>{
	  
    return { type: PowerBIConstants.POWERBI_API_FAILURE, payload : instanceId};
}

export {
	addDeviceToPowerBIReducerState,
	removeDeviceFromPowerBIReducerState,
	getPowerBIData,
	getWorkspaceID
}